import TemplateEditCreateForm from "../template-form";

export const EditTemplate = () => {
  return <TemplateEditCreateForm />;
};

export default EditTemplate;
